<app-box-section [title]="'carDetail.priceCompare.title' | translate">
  @if (car) {
    <div class="car-detail__price-compare">
      <div class="car-detail__price-compare-header">
        <app-title class="car-detail__price-compare-header-title" [tag]="'h2'" [tag-class]="'h4'">{{ 'carDetail.priceCompare.discountTitle' | translate }} {{ car.price.original - car.price.cash | price }}</app-title>
        <app-paragraph class="car-detail__price-compare-header-info">{{ 'carDetail.priceCompare.description' | translate: { price: (car.price.original | price) } }}</app-paragraph>
      </div>
      <div class="car-detail__price-compare-main">
        <div class="car-detail__price-compare-graph-legend">
          <div class="car-detail__price-compare-graph-legend-item"><app-icon [icon]="'logo-alt'" [height]="12" [color]="'primary'"></app-icon> Mototechna</div>
          <div class="car-detail__price-compare-graph-legend-item">
            <div class="car-detail__price-compare-graph-legend-marker"></div>
            {{ 'carDetail.priceCompare.newCar' | translate }}
          </div>
        </div>
        <div class="car-detail__price-compare-graph">
          <div class="car-detail__price-compare-graph-inner">
            <app-image class="car-detail__price-compare-graph-image" [src]="'images/price-compare.svg'" [width]="304" [height]="82" [placeholder]="false" [alt]="'carDetail.priceCompare.discountTitle' | translate"></app-image>
            <div class="car-detail__price-compare-bar car-detail__price-compare-bar--our-value">
              <span class="car-detail__price-compare-bar-value car-detail__price-compare-bar-value--our-value">{{ car.price.cash | price }}</span>
            </div>
            <div class="car-detail__price-compare-bar">
              <span class="car-detail__price-compare-bar-value">{{ car.price.original | price }}</span>
            </div>
            <div class="car-detail__price-compare-difference">
              <app-icon [icon]="'decrease'" [width]="24" [height]="24"></app-icon>
              {{ car.price.original - car.price.cash | price }}
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</app-box-section>
